<template>
    <div v-if="currentReport">
        <v-row>
            <v-col cols="12">
                <h1>{{ t('reports::trackers.title.trackers_report') }}{{ currentReport.title }}</h1>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-row class="table-head">
                    <v-col cols="12" lg="6" class="table-head-filters">
                        <v-row>
                            <v-col cols="12" lg="9">
                                <b-filter-date
                                    ref="dateFilter"
                                    v-model="dateFilter"
                                    type="month"
                                    :label="t('reports::filters.label.date')"
                                    @change="setReportFilter"
                                    @clear="filterDateClear"
                                ></b-filter-date>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" lg="6" class="table-head-actions">
                        <v-btn
                            v-if="can('api.v1.trackers.reports.trackers.store')"
                            color="primary"
                            small
                            rounded
                            text
                            :loading="generateTrackersReportLoading"
                            @click="generateReport"
                            >{{ t('reports::button.generate_report') }}</v-btn
                        >
                        <v-btn
                            v-if="can('api.v1.trackers.reports.trackers.index')"
                            color="primary"
                            small
                            rounded
                            class="ml-2"
                            @click="fetchReportsList"
                            >{{ t('reports::button.view_reports') }}</v-btn
                        >
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-tabs v-model="tab" show-arrows>
            <v-tab v-for="(item, index) in tabsHeaders" :key="index">
                <div class="tab">{{ item }}</div>
            </v-tab>
        </v-tabs>
        <v-tabs-items
            v-model="tab"
            class="py-0"
            transition="scroll-x-reverse-transition"
            reverse-transition="scroll-x-transition"
        >
            <v-tab-item v-for="(item, index) in tabsItems" :key="index">
                <v-col cols="12">
                    <component :is="item.component"></component>
                </v-col>
            </v-tab-item>
        </v-tabs-items>
        <trackers-reports-list-modal ref="previewModal"></trackers-reports-list-modal>
    </div>
</template>

<script>
export default {
    name: 'TrackersTabsComponent',
    components: {},
    data() {
        return {
            generateTrackersReportLoading: false,
            dateFilter: null,
        };
    },
    computed: {
        tab: {
            get() {
                return this.$store.state.trackers.tab;
            },
            set(tab) {
                const item = this.tabsItems[tab];
                if (item && item.type) {
                    this.$store.dispatch('trackers/setType', item.type);
                    this.loadReport();
                }
                return this.$store.dispatch('trackers/changeTab', tab);
            },
        },
        loading: {
            get() {
                return this.$store.state.trackers.loading;
            },
            set(loading) {
                return this.$store.dispatch('trackers/setLoading', loading);
            },
        },
        tabsHeaders() {
            return this.$store.state.trackers.tabsHeaders;
        },
        tabsItems() {
            return this.$store.state.trackers.tabsItems;
        },
        currentReport() {
            return this.$store.state.trackers.currentReport;
        },
        urlReportType() {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get('type');
        },
    },
    watch: {},
    mounted() {
        _.delay(
            () => {
                this.setTab(this.urlReportType);
            },
            100,
            'latter'
        );
        if (!this.currentReportFitler) {
            this.setReportFilter();
        }
    },
    methods: {
        setTab(type) {
            switch (type) {
                case 'red-results':
                    return (this.tab = 0);
                case 'amber-results':
                    return (this.tab = 1);
                case 'rechallenged-patients':
                    return (this.tab = 2);
                default:
                    break;
            }
        },
        fetchReportsList() {
            this.$store.dispatch('trackers/fetchTrackersReportsList', new Object());
            this.$refs.previewModal.viewReportsModal = true;
        },
        generateReport() {
            this.generateTrackersReportLoading = true;
            this.$store
                .dispatch('trackers/generateTrackersReport', this.currentReportFitler)
                .then(() => {
                    this.$root.notify(
                        'info',
                        t('default::notification.success'),
                        t('reports::trackers.trackers.report.generate')
                    );
                })
                .catch((error) => {
                    this.$root.notify('error', error.response.data.error);
                })
                .finally(() => _.delay(() => (this.generateTrackersReportLoading = false), 400));
        },
        filterDateClear() {
            this.dateFilter = null;
            this.loading = true;
            _.delay(() => {
                this.dateFilter = `${moment(new Date()).format('Y-MM')}`;
                this.loading = false;
                this.setReportFilter();
            }, 1000);
        },
        setReportFilter(filter = null) {
            if (!filter) {
                this.dateFilter = `${moment(new Date()).format('Y-MM')}`;
            }
            const year = parseInt(moment(filter).format('Y')) || parseInt(moment(new Date()).format('Y'));
            const month = parseInt(moment(filter).format('M')) || parseInt(moment(new Date()).format('M'));
            this.currentReportFitler = { year, month };
            this.$refs.dateFilter.onClose();
            return this.loadReport();
        },
        loadReport() {
            if (!this.currentReport && !this.currentReportFitler) {
                return;
            }
            this.loading = true;
            axios
                .get(route(this.currentReport.route, this.currentReportFitler))
                .then((response) => {
                    const data = _.clone(response.data.data);
                    const meta = _.clone(response.data.meta);
                    if (data) {
                        this.$store.dispatch('trackers/setCurrentReportItems', data);
                    }
                    if (meta) {
                        this.$store.dispatch('trackers/setCurrentReportMeta', meta);
                    }
                })
                .catch((error) => {
                    this.$root.notify('error', error.response.data.error);
                })
                .finally(() => {
                    _.delay(
                        () => {
                            this.loading = false;
                        },
                        301,
                        'latter'
                    );
                });
        },
    },
};
</script>
